import {call, put} from 'redux-saga/effects';
import {receiveFacilitiesData, errorRetrievingFacilitiesData} from "../actions/facilitiesActions";
import {fetchFacilitiesData} from "../api/fetchFacilitiesData";

export default function* getFacilitiesData(action) {
  try {
    const rawFacilitiesData = yield call(fetchFacilitiesData);
    yield put(receiveFacilitiesData(rawFacilitiesData));
  } catch (e) {
    console.log(e);
    yield put(errorRetrievingFacilitiesData(e.message));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/facilitiesSaga.js